import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from '../../../utils/api';
import { GET_SPECIALIZATIONS_QUERY_KEY } from './useCreateSpecializationMutation';

export interface Specialization {
  id: number;
  name: string;
  code: string;
  description: string;
  academicProgramId: number;
  isDeleted: boolean;
  activeStatus: boolean;
  institutionShortName: string;
}

interface SpecializationResponse {
  code: number;
  message: string;
  data: Specialization[];
}

export const useGetSpecializationQuery = () => {
  const fetchSpecializations = async (): Promise<SpecializationResponse> => {
    return (await api.get('/Concentration'))?.data;
  };

  const { data, isLoading, isError, error, refetch } = useQuery<SpecializationResponse, AxiosError<ApiErrorResponse>>({
    queryKey: GET_SPECIALIZATIONS_QUERY_KEY,
    queryFn: fetchSpecializations,
  });

  const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch specializations';

  return {
    data,
    specializationData: data?.data ?? [],
    isLoading,
    isSpecializationLoading: isLoading,
    isError,
    isSpecializationError: isError,
    errorMessage,
    specializationErrorMessage: errorMessage,
    refetch,
  };
};
